__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@marah.cloud/tour-planing";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tomfxs/pukeko", "2.0.14", () => (Promise.all([__webpack_require__.e(699), __webpack_require__.e(995), __webpack_require__.e(747), __webpack_require__.e(56)]).then(() => (() => (__webpack_require__(58699))))));
			register("i18next", "21.10.0", () => (Promise.all([__webpack_require__.e(367), __webpack_require__.e(703)]).then(() => (() => (__webpack_require__(33367))))));
			register("luxon", "3.4.4", () => (__webpack_require__.e(126).then(() => (() => (__webpack_require__(17126))))));
			register("react-dnd-touch-backend", "16.0.1", () => (__webpack_require__.e(132).then(() => (() => (__webpack_require__(85132))))));
			register("react-dnd", "16.0.1", () => (Promise.all([__webpack_require__.e(646), __webpack_require__.e(747), __webpack_require__.e(63)]).then(() => (() => (__webpack_require__(8646))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(747)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-i18next", "11.18.6", () => (Promise.all([__webpack_require__.e(747), __webpack_require__.e(735)]).then(() => (() => (__webpack_require__(39735))))));
			register("react-router-dom", "6.23.1", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(747), __webpack_require__.e(56)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(39974);
			initExternal(37469);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};